import { Link } from "react-router-dom";

export const SiteFooter = () => {
  return (
    <footer
      className="flex min-h-[42px] w-full items-center justify-center bg-[#173E72] px-3 py-2"
      data-testid="site-footer"
    >
      <p
        className="text-center text-[12px] font-normal text-[#F8F2E6] md:whitespace-nowrap md:text-[13px]"
        style={{ fontFamily: '"Roboto Slab", serif' }}
      >
        © 2026 Paw-some Reports. All rights reserved.
        <span className="mx-3 md:mx-5">|</span>
        <a href="mailto:hello@pawsomereports.com" className="hover:underline">
          Contact
        </a>
        <span className="md:hidden">
          <span className="mx-3">|</span>
          <Link to="/admin" className="hover:underline" data-testid="mobile-admin-link">
            Admin
          </Link>
        </span>
      </p>
    </footer>
  );
};

export default SiteFooter;
